import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { BaseComponentService } from '../../services/base-component.service';
import { UnidadeOrcamentaria } from '../../models/pagamento/unidade-orcamentaria';
import { ContaBancariaEstado } from '../../models/pagamento/conta-bancaria-estado';
import { OrdenadorDespesa } from '../../models/pagamento/ordenador-despesa';
import { TipoDespesa } from '../../models/pagamento/tipo-despesa';
import { TipoEmpenho } from '../../models/pagamento/tipo-empenho';
import { UnidadeGestora } from '../../models/pagamento/unidade-gestora';
import { UnidadeCusto } from '../../models/pagamento/unidade-custo';
import { TipoInstrumento } from '../../models/pagamento/tipo-instrumento';
import { TipoGasto } from '../../models/pagamento/tipo-gasto';
import { DotacaoOrcamentaria } from '../../models/pagamento/dotacao-orcamentaria';
import { ModalidadeLicitacao } from '../../models/pagamento/modalidade-licitacao';
import { LiberadorPagamento } from '../../models/pagamento/liberador-pagamento';

@Component({
  selector: 'gpa-param-pagamento',
  templateUrl: './param-pagamento.component.html',
  providers: [BaseComponentService]
})
export class ParamPagamentoComponent extends BaseComponentService implements OnInit {

  @Input() modoEdicao: boolean;

  maskDotacao: Array<string | RegExp> = [
    /\d/, /\d/, /\d/, /\d/, /\d/, '.',
    /\d/, /\d/, /\d/, /\d/, '.',
    /\d/, /\d/, '.',
    /\d/, /\d/, /\d/, '.',
    /\d/, /\d/, /\d/, '.',
    /\d/, /\d/, /\d/, /\d/, '.',
    /\d/, /\d/, /\d/, /\d/, '.',
    /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '.',
    /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '.',
    /\d/
  ];

  //  Limites de dias permitidos para a previsão de pagamento e e vencimento da despesa.
  numMinimoDias: number = 0;
  numMaximoDias: number = 90;

  subscription: Subscription;
  parametroCadastrado: boolean;
  parametroPagamento: ParametroPagamentoDto;
  paramPagamentoForm: FormGroup;

  /*
   *  Controles do formulário
   */
  fcAnoExercicio: FormControl;
  fcContaBancariaEstado: FormControl;
  fcUnidadeOrcamentaria: FormControl;
  fcUnidadeGestora: FormControl;
  fcUnidadeCusto: FormControl;
  fcTipoInstrumento: FormControl;
  fcTipoDespesa: FormControl;
  fcTipoEmpenho: FormControl;
  fcTipoGasto: FormControl;
  fcModalidadeLicitacao: FormControl;
  fcOrdenadorDespesa: FormControl;
  fcDotacaoOrcamentaria: FormControl;
  fcLiberadorPagamento: FormControl;
  fcCompetenciaAnterior: FormControl;
  fcPeriodoCompetencia: FormControl;
  fcDiasPrevisaoPagamento: FormControl;
  fcDataPrevisaoPagamento: FormControl;
  fcDiasVencimentoDespesa: FormControl;
  fcDataVencimentoDespesa: FormControl;

  /*
   *   Variáveis relacionadas à validação do forrmulário com mensagem de erro de cada controle.
   */
  msgErroAnoExercicio: string = 'Por favor, informe o ano do exercício.';
  msgErroContaBancariaEstado: string = 'Por favor, informe uma conta bancária do Estado.';
  msgErroUnidadeOrcamentaria: string = 'Por favor, informe uma unidade orçamentária.';
  msgErroUnidadeGestora: string = 'Por favor, informe uma unidade gestora.';
  msgErroUnidadeCusto: string = 'Por favor, informe uma unidade de custo.';
  msgErroTipoInstrumento: string = 'Por favor, informe um tipo de instrumento.';
  msgErroTipoDespesa: string = 'Por favor, informe um tipo de despesa.';
  msgErroTipoEmpenho: string = 'Por favor, informe um tipo de empenho.';
  msgErroTipoGasto: string = 'Por favor, informe um tipo de gasto.';
  msgErroModalidadeLicitacao: string = 'Por favor, informe uma modalidade de licitação.';
  msgErroDotacaoOrcamentaria: string = 'Por favor, informe uma dotação orçamentária.';
  msgErroOrdenadorDespesa: string = 'Por favor, informe um ordenador de despsa.';
  msgErroLiberadorPagamento: string = 'Por favor, informe um liberador de pagamento.';
  msgErroPrevisaoPagamento: string = 'Por favor, informe o número de dias para a previsão de pagamento.';
  msgErroVencimentoDespesa: string = 'Por favor, informe o número de dias para o vencimento da despesa.';
  msgErroNumDias: string = 'Por favor, informe um número entre ' + this.numMinimoDias + ' e ' + this.numMaximoDias + ', inclusive.';

  /*
   * Arrays para armazenamento da listas dos selects.
   */
  contasBancariasEstado: ContaBancariaEstado[];
  unidadesOrcamentarias: UnidadeOrcamentaria[];
  unidadesGestoras: UnidadeGestora[];
  unidadesCusto: UnidadeCusto[];
  tiposEmpenho: TipoEmpenho[];
  tiposGasto: TipoGasto[];
  tiposDespesa: TipoDespesa[];
  tiposInstrumento: TipoInstrumento[];
  dotacoesOrcamentarias: DotacaoOrcamentaria[];
  modalidadesLicitacao: ModalidadeLicitacao[];
  ordenadoresDespesa: OrdenadorDespesa[];
  liberadoresPagamento: LiberadorPagamento[];

  competenciaAnterior: boolean = true;
  diasPrevisaoPagamento: number;
  dataPrevisaoPagamento: Date;
  diasVencimentoDespesa: number;
  dataVencimentoDespesa: Date;

  projetoIntegrado: string;
  anoExercicioAtual: number;

  ngOnInit() {

    this.anoExercicioAtual = new Date().getFullYear();
    this.projetoIntegrado = sessionStorage.getItem('ProjetoIntegrado');

    this.criarControlesFormulario();
    this.criarFormulario();
    
    if (this.modoEdicao) {
      // Controles do formuário que precisam ser desabilitados pois dependem de que outros tenham valores.       
      this.disableFormControls([
        this.fcUnidadeCusto,
        this.fcUnidadeGestora,
        this.fcDotacaoOrcamentaria,
        this.fcOrdenadorDespesa,
        this.fcLiberadorPagamento
      ]);
    }
    else {
      this.disableFormControls([
        this.fcAnoExercicio,
        this.fcContaBancariaEstado,
        this.fcUnidadeOrcamentaria,
        this.fcTipoDespesa,
        this.fcTipoEmpenho,
        this.fcTipoGasto,
        this.fcTipoInstrumento,
        this.fcModalidadeLicitacao,
        this.fcUnidadeCusto,
        this.fcUnidadeGestora,
        this.fcDotacaoOrcamentaria,
        this.fcOrdenadorDespesa,
        this.fcLiberadorPagamento,
        this.fcCompetenciaAnterior,
        this.fcDiasPrevisaoPagamento,
        this.fcDiasVencimentoDespesa
      ]);
    }

    this.disableFormControls([
      this.fcDataPrevisaoPagamento,
      this.fcDataVencimentoDespesa
    ]);

    this.contasBancariasEstado = [];
    this.unidadesOrcamentarias = [];
    this.unidadesGestoras = [];
    this.unidadesCusto = [];
    this.tiposDespesa = [];
    this.tiposGasto = [];
    this.tiposInstrumento = [];
    this.tiposEmpenho = [];
    this.ordenadoresDespesa = [];
    this.dotacoesOrcamentarias = [];
    this.modalidadesLicitacao = [];
    this.liberadoresPagamento = [];

    /*
     * Carrega os arrays utilizados nas listas dos selects.
     */
    this.preencheCombo('/api/UnidadeOrcamentaria/GetTodos', 'unidadesOrcamentarias', 'gpa');
    this.preencheCombo('/api/TipoInstrumento/GetTodos', 'tiposInstrumento', 'gpa');
    this.preencheCombo('/api/TipoEmpenho/GetTodos', 'tiposEmpenho', 'gpa');
    this.preencheCombo('/api/TipoGasto/GetByAno/' + this.anoExercicioAtual, 'tiposGasto', 'gpa');
    this.preencheCombo('/api/ModalidadeLicitacao/GetTodos', 'modalidadesLicitacao', 'gpa');
      
    /*
     * Passa o modo de edição para permitir ou não a exibição do modal de dados não cadastrados para o exercício.
     */
    this.getParametrosPagamento(this.anoExercicioAtual, this.modoEdicao);
  }

  criarControlesFormulario() {
    this.fcAnoExercicio = new FormControl(this.anoExercicioAtual, Validators.required);
    this.fcContaBancariaEstado = new FormControl('', Validators.required);
    this.fcUnidadeOrcamentaria = new FormControl('', Validators.required);
    this.fcUnidadeGestora = new FormControl('', Validators.required);
    this.fcUnidadeCusto = new FormControl('', Validators.required);
    this.fcTipoEmpenho = new FormControl('', Validators.required);
    this.fcTipoDespesa = new FormControl('', Validators.required);
    this.fcTipoGasto = new FormControl('', Validators.required);
    this.fcTipoInstrumento = new FormControl('', Validators.required);
    this.fcOrdenadorDespesa = new FormControl('', Validators.required);
    this.fcDotacaoOrcamentaria = new FormControl('', Validators.required);
    this.fcModalidadeLicitacao = new FormControl('', Validators.required);
    this.fcLiberadorPagamento  = new FormControl('', Validators.required);
    this.fcCompetenciaAnterior = new FormControl('', Validators.required);
    this.fcPeriodoCompetencia = new FormControl('');
    this.fcDiasPrevisaoPagamento = new FormControl('', [Validators.required, 
        Validators.min(this.numMinimoDias), Validators.max(this.numMaximoDias)]);
    this.fcDataPrevisaoPagamento = new FormControl('');
    this.fcDiasVencimentoDespesa = new FormControl('', [Validators.required, 
        Validators.min(this.numMinimoDias), Validators.max(this.numMaximoDias)]);
    this.fcDataVencimentoDespesa = new FormControl('');
  }

  criarFormulario() {
    this.paramPagamentoForm = new FormGroup({
      anoExercicio: this.fcAnoExercicio,
      contaBancariaEstado: this.fcContaBancariaEstado,
      unidadeOrcamentaria: this.fcUnidadeOrcamentaria,
      unidadeGestora: this.fcUnidadeGestora,
      unidadeCusto: this.fcUnidadeCusto,
      tipoInstrumento: this.fcTipoInstrumento,
      tipoDespesa: this.fcTipoDespesa,
      tipoEmpenho: this.fcTipoEmpenho,
      tipoGasto: this.fcTipoGasto,
      dotacaoOrcamentaria: this.fcDotacaoOrcamentaria,
      ordenadorDespesa: this.fcOrdenadorDespesa,
      modalidadeLicitacao: this.fcModalidadeLicitacao,
      liberadorPagamento: this.fcLiberadorPagamento,
      competenciaAnterior: this.fcCompetenciaAnterior,
      diasPrevisaoPagamento: this.fcDiasPrevisaoPagamento,
      dataPrevisaoPagamento: this.fcDataPrevisaoPagamento,
      diasVencimentoDespesa: this.fcDiasVencimentoDespesa,
      dataVencimentoDespesa: this.fcDataVencimentoDespesa
    });
  }

  atualizarFormulario(paramPagamento: ParametroPagamentoDto) {
    this.fcContaBancariaEstado.setValue(paramPagamento === null ? '' : paramPagamento.codigoContaBancariaEstado);
    this.fcUnidadeOrcamentaria.setValue(paramPagamento === null ? '' : paramPagamento.codigoUnidadeOrcamentaria);
    this.fcUnidadeGestora.setValue(paramPagamento === null ? '' : paramPagamento.codigoUnidadeGestora);
    this.fcUnidadeCusto.setValue(paramPagamento === null ? '' : paramPagamento.codigoUnidadeCusto);
    this.fcTipoInstrumento.setValue(paramPagamento === null ? '' : paramPagamento.codigoTipoInstrumento);
    this.fcTipoDespesa.setValue(paramPagamento === null ? '' : paramPagamento.tipoDespesaId);
    this.fcTipoEmpenho.setValue(paramPagamento === null ? '' : paramPagamento.codigoTipoEmpenho);
    this.fcTipoGasto.setValue(paramPagamento === null ? '' : paramPagamento.sequencialTipoGasto);
    this.fcDotacaoOrcamentaria.setValue(paramPagamento === null ? '' : paramPagamento.dotacaoOrcamentariaId);
    this.fcOrdenadorDespesa.setValue(paramPagamento === null ? '' : paramPagamento.codigoOrdenadorDespesa);
    this.fcModalidadeLicitacao.setValue(paramPagamento === null ? '' : paramPagamento.codigoModalidadeLicitacao);

    this.fcLiberadorPagamento.setValue(paramPagamento === null || paramPagamento.codigoLiberadorPagamento == -1
      ? '' : paramPagamento.codigoLiberadorPagamento);
    
    this.fcCompetenciaAnterior.setValue(paramPagamento === null ? this.competenciaAnterior : paramPagamento.competenciaAnterior);
    
    this.fcDiasPrevisaoPagamento.setValue(paramPagamento === null || paramPagamento.diasPrevisaoPagamento == -1
      ? '' : paramPagamento.diasPrevisaoPagamento);
    
    this.fcDiasVencimentoDespesa.setValue(paramPagamento === null || paramPagamento.diasVencimentoDespesa == -1
      ? '' : paramPagamento.diasVencimentoDespesa);    
    
    this.fcDataPrevisaoPagamento.setValue(paramPagamento === null  || paramPagamento.diasPrevisaoPagamento == -1
      ? '' : this.convertDate(this.retornaDataFutura(paramPagamento.diasPrevisaoPagamento), 'dd/MM/yyyy')
    );
    this.fcDataVencimentoDespesa.setValue(paramPagamento === null || paramPagamento.diasVencimentoDespesa == -1
      ? '' : this.convertDate(this.retornaDataFutura(paramPagamento.diasVencimentoDespesa), 'dd/MM/yyyy')
    );      
  }

  /*
  * Limpa o formulário e desabilita os controles que dependam dos valores de outros.
  */
  limparOnClick() {
    this.atualizarFormulario(null);

    this.disableFormControls([
      this.fcUnidadeCusto,
      this.fcUnidadeGestora,

    ]);
  }

  salvarOnClick() {

    Object.keys(this.paramPagamentoForm.controls).forEach(key => {
      this.paramPagamentoForm.controls[key].markAsDirty();
    });

    if (this.paramPagamentoForm.invalid) {
      return;
    }
  
    let params: ParametroPagamentoDto;
    params = {
      codigoProjeto: this.projetoIntegrado,
      anoExercicio: this.fcAnoExercicio.value,
      dotacaoOrcamentariaId: this.fcDotacaoOrcamentaria.value,
      codigoUnidadeOrcamentaria: this.fcUnidadeOrcamentaria.value,
      codigoUnidadeGestora: this.fcUnidadeGestora.value,
      codigoUnidadeCusto: this.fcUnidadeCusto.value,
      codigoTipoInstrumento: this.fcTipoInstrumento.value,
      tipoDespesaId: this.fcTipoDespesa.value,
      codigoTipoEmpenho: this.fcTipoEmpenho.value,
      sequencialTipoGasto: this.fcTipoGasto.value,
      codigoModalidadeLicitacao: this.fcModalidadeLicitacao.value,
      codigoOrdenadorDespesa: this.fcOrdenadorDespesa.value,
      codigoContaBancariaEstado: this.fcContaBancariaEstado.value,
      codigoLiberadorPagamento: this.fcLiberadorPagamento.value,
      competenciaAnterior: this.fcCompetenciaAnterior.value,
      diasPrevisaoPagamento: this.fcDiasPrevisaoPagamento.value,
      diasVencimentoDespesa: this.fcDiasVencimentoDespesa.value
    }

    this.save('/api/ParametroPagamento', params, this.parametroCadastrado, 'gpa');

  }

  /*
  *   Obtém os parâmetros do exercício informado.
  *
  *   anoExercicio: Ano do exercício.
  *   exibirMensagem: Status de exibição do modal com mensagem de aviso ou erro.
  *       O modal será exibido quando o componente estiver no modo de edição.
  *       No modo de consulta não há necessidade.
  */
  getParametrosPagamento(anoExercicio: number, exibirMensagem: boolean) {
    this._service.routePrefix = '/api/ParametroPagamento/Obter/'.concat(
      `${this.projetoIntegrado}/${anoExercicio}`);

    this.aslibLoadingService.start();

    this.subscription = this._service.getAll('gpa')
      .subscribe(res => {
        const parametros: ParametroPagamentoDto = res;
        
        this.atualizarFormulario(parametros);

        this.preencheComboUmParametro('/api/ContaBancariaEstado/GetByAnoReferencia', 'contasBancariasEstado', 
          this.fcAnoExercicio.value, 'gpa');

        this.preencheComboUmParametro('/api/TipoDespesa/GetByAnoExercicio', 'tiposDespesa',this.fcAnoExercicio.value, 'gpa');

        if (parametros === null) {
          this.parametroCadastrado = false;

          this.disableFormControls([
            this.fcUnidadeCusto,
            this.fcUnidadeGestora,
            this.fcDotacaoOrcamentaria,
            this.fcOrdenadorDespesa,
            this.fcLiberadorPagamento
          ]);

          if (exibirMensagem) {
            this.exibirAviso('Não foram encontradas informações de pagamentos para o ano de exercício informado.');
          }
        }
        else {
          this.parametroCadastrado = true;

          

          this.preencheComboUmParametro('/api/UnidadeGestora/GetByCodigoUnidadeOrcamentaria/', 'unidadesGestoras',
            this.fcUnidadeOrcamentaria.value, 'gpa');

          this.preencheComboDoisParametros('/api/UnidadeCusto/GetByUnidadeOrcamentariaUnidadeGestora/', 'unidadesCusto',
            this.fcUnidadeOrcamentaria.value, this.fcUnidadeGestora.value,'gpa');

          this.preencheComboTresParametros('/api/DotacaoOrcamentaria/GetByAnoUnidadeOrcamentariaUnidadeGestora/', 'dotacoesOrcamentarias',
            this.fcAnoExercicio.value, this.fcUnidadeOrcamentaria.value, this.fcUnidadeGestora.value, 'gpa');

          this.preencheComboTresParametros('/api/OrdenadorDespesa/GetByAnoUnidadeOrcamentariaUnidadeGestora/', 'ordenadoresDespesa',
            this.fcAnoExercicio.value, this.fcUnidadeOrcamentaria.value, this.fcUnidadeGestora.value, 'gpa');

          this.preencheComboTresParametros('/api/LiberadorPagamento/GetByAnoUnidadeOrcamentariaUnidadeGestora/', 'liberadoresPagamento',
            this.fcAnoExercicio.value, this.fcUnidadeOrcamentaria.value, this.fcUnidadeGestora.value, 'gpa');


          if (this.modoEdicao) {
              this.enableFormControls([
              this.fcUnidadeCusto,
              this.fcUnidadeGestora,
              this.fcDotacaoOrcamentaria,
              this.fcOrdenadorDespesa, 
              this.fcLiberadorPagamento
            ]);
          }
        }
      },
        (error) => {
          if (exibirMensagem) {
            this.exibirErro(error);
            this.aslibLoadingService.complete();
          }
        },
        () => {
          this.aslibLoadingService.complete();
          if (this.subscription) {
            this.subscription.unsubscribe();
          }
        }
      );
  }

  /*
   *
   * Eventos "change" de alguns selects.
   *
   */
  changeUnidadeOrcamentaria() {
    /*
     * É necessária a seleção de unidade orçamentária para que as unidades gestoras sejam disponibilizas.
     */
    this.unidadesGestoras = [];
    this.clearFormControl(this.fcUnidadeGestora);
    this.setStateFormControl(this.fcUnidadeGestora, !this.formControlIsNull(this.fcUnidadeOrcamentaria));

       this.preencheComboUmParametro('/api/UnidadeGestora/GetByCodigoUnidadeOrcamentaria/', 'unidadesGestoras',
            this.fcUnidadeOrcamentaria.value, 'gpa');
    this.changeUnidadeGestora();
  }

  changeUnidadeGestora() {
    /*
     * São necessárias as seleções de unidade orçamentária e unidade gestora para que as as unidades de custo,
     * as dotações orçamentárias e os ordenadores de despesa sejam disponibilizadas.
     */
    const selecionouOrcamentariaGestora = !this.formControlIsNull(this.fcUnidadeOrcamentaria) && !this.formControlIsNull(this.fcUnidadeGestora);

    this.unidadesCusto = [];
    this.clearFormControl(this.fcUnidadeCusto);
    this.setStateFormControl(this.fcUnidadeCusto, selecionouOrcamentariaGestora);

    this.dotacoesOrcamentarias = [];
    this.clearFormControl(this.fcDotacaoOrcamentaria);
    this.setStateFormControl(this.fcDotacaoOrcamentaria, selecionouOrcamentariaGestora);

    this.ordenadoresDespesa = [];
    this.clearFormControl(this.fcOrdenadorDespesa);
    this.setStateFormControl(this.fcOrdenadorDespesa, selecionouOrcamentariaGestora);
    
    this.liberadoresPagamento = [];
    this.clearFormControl(this.fcLiberadorPagamento);
    this.setStateFormControl(this.fcLiberadorPagamento, selecionouOrcamentariaGestora);

    if (selecionouOrcamentariaGestora) {
        this.preencheComboDoisParametros('/api/UnidadeCusto/GetByUnidadeOrcamentariaUnidadeGestora/', 'unidadesCusto',
            this.fcUnidadeOrcamentaria.value, this.fcUnidadeGestora.value,'gpa');
    }

    if (selecionouOrcamentariaGestora) {
        this.preencheComboTresParametros('/api/DotacaoOrcamentaria/GetByAnoUnidadeOrcamentariaUnidadeGestora/', 'dotacoesOrcamentarias',
            this.fcAnoExercicio.value, this.fcUnidadeOrcamentaria.value, this.fcUnidadeGestora.value, 'gpa');
    }

    if (selecionouOrcamentariaGestora) {
      this.preencheComboTresParametros('/api/OrdenadorDespesa/GetByAnoUnidadeOrcamentariaUnidadeGestora/', 'ordenadoresDespesa',
        this.fcAnoExercicio.value, this.fcUnidadeOrcamentaria.value, this.fcUnidadeGestora.value, 'gpa');
    }

    if (selecionouOrcamentariaGestora) {
      this.preencheComboTresParametros('/api/LiberadorPagamento/GetByAnoUnidadeOrcamentariaUnidadeGestora/', 'liberadoresPagamento',
        this.fcAnoExercicio.value, this.fcUnidadeOrcamentaria.value, this.fcUnidadeGestora.value, 'gpa');
    }
  }

  setDataPrevisaoPagamento(dias: string) {
    this.dataPrevisaoPagamento = this.retornaDataFutura(Number(dias));
  }

  setDataVencimentoDespesa(dias: string) {
    this.dataVencimentoDespesa = this.retornaDataFutura(Number(dias));
  }

  retornaDataFutura(dias: number) : Date {  
    var data = new Date();    
    var dataFutura = new Date(data.setDate(data.getDate() + dias));

    if (dataFutura.getDay() === 0) {
      dataFutura = new Date(dataFutura.setDate(dataFutura.getDate() + 1))
    }
    else if (dataFutura.getDay() === 6) {
      dataFutura = new Date(dataFutura.setDate(dataFutura.getDate() + 2))
    }
    
    return dataFutura;
  } 

}



// WEBPACK FOOTER //
// ./src/app/parametros/param-pagamento/param-pagamento.component.ts